export default __webpack_public_path__ + "a7c716383391e47e9adfe2ea3b15587b.svg";